<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.form-section {
  border: 1px solid $primary;
  margin-top: 20px;
  padding: 10px;
}
h3 {
  background-color: #fff;
  margin-top: -25px;
}
span {
  margin: 20px 0;
}
</style>
<template lang="pug">
.frow.form-section.column-start.mb-25.width-100
  h3 {{ title }}
  span(v-if="!printOut") - {{ description }}
  slot
</template>
<script>
export default {
  name: "form-section",
  components: {},
  props: {
    printOut: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Title"
    },
    description: {
      type: String,
      default: "Description"
    }
  },
  data: () => ({})
};
</script>
